// extracted by mini-css-extract-plugin
export default {"container":"NewReview_container__gykDW"};